export default __webpack_public_path__ + "static/media/Dutra.e1a44cb8.png";